import InPageMessage from '@liveauctioneers/caterwaul-components/lib/InPageMessage/InPageMessage';
import { ReactNode } from 'react';

type Props = {
    message: ReactNode;
};

export const ExpiredCheckoutMessage = ({ message }: Props) => {
    return (
        <InPageMessage
            className="mb-sm"
            type="error"
        >
            {message}
        </InPageMessage>
    );
};
